import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetItemAvailabilityQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.ItemAvailabilityDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.ItemAvailabilityDocumentSortInput> | Types.ItemAvailabilityDocumentSortInput>;
}>;


export type GetItemAvailabilityQuery = { __typename?: 'Query', itemAvailability: Array<{ __typename?: 'ItemAvailabilityDocument', id: string, recordedAt: Types.TDateISO, itemId: string, itemName: string, upc: string, sku: string, quantity: number, tenantId: string }> };

export type ItemAvailabilityFragment = { __typename?: 'ItemAvailabilityDocument', id: string, recordedAt: Types.TDateISO, itemId: string, itemName: string, upc: string, sku: string, quantity: number, tenantId: string };

export type ResolveAvailabilityImportItemsQueryVariables = Types.Exact<{
  items: Array<Types.AvailabilityImportItemInput> | Types.AvailabilityImportItemInput;
}>;


export type ResolveAvailabilityImportItemsQuery = { __typename?: 'Query', resolveAvailabilityImportItems: { __typename?: 'AvailabilityImportItemResolutionPayload', items?: Array<{ __typename?: 'AvailabilityImportItemResolutionData', rowIndex: number, itemId?: string | null, itemMatcher: string, status: Types.AvailabilityImportItemMatchStatus }> | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type GetAvailabilityPhotoGradeSuggestionQueryVariables = Types.Exact<{
  photoId: Types.Scalars['String']['input'];
}>;


export type GetAvailabilityPhotoGradeSuggestionQuery = { __typename?: 'Query', availabilityPhotoGradeSuggestion?: { __typename?: 'AvailabilityPhotoGradeSuggestion', photoId: string, itemId: string, grade: number } | null };

export type GetItemAvailabilityByDateQueryVariables = Types.Exact<{
  input: Types.ItemAvailabilityByDateInput;
}>;


export type GetItemAvailabilityByDateQuery = { __typename?: 'Query', itemAvailabilityByDate: { __typename?: 'ItemAvailabilityByDatePayload', items?: Array<{ __typename?: 'ItemAvailabilityByDate', itemId: string, asOf: Types.TDateISO, onHandReadyBy: number, plantedReadyBy: number, openDemandDueBy: number, availableBy: number, plannedReadyBy: number }> | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export const ItemAvailabilityFragmentDoc = new TypedDocumentString(`
    fragment ItemAvailability on ItemAvailabilityDocument {
  id
  recordedAt
  itemId
  itemName
  upc
  sku
  quantity
  tenantId
}
    `, {"fragmentName":"ItemAvailability"});
export const GetItemAvailabilityDocument = new TypedDocumentString(`
    query GetItemAvailability($where: ItemAvailabilityDocumentFilterInput, $order: [ItemAvailabilityDocumentSortInput!]) {
  itemAvailability(where: $where, order: $order) {
    ...ItemAvailability
  }
}
    fragment ItemAvailability on ItemAvailabilityDocument {
  id
  recordedAt
  itemId
  itemName
  upc
  sku
  quantity
  tenantId
}`);
export const ResolveAvailabilityImportItemsDocument = new TypedDocumentString(`
    query ResolveAvailabilityImportItems($items: [AvailabilityImportItemInput!]!) {
  resolveAvailabilityImportItems(items: $items) {
    items {
      rowIndex
      itemId
      itemMatcher
      status
    }
    errors {
      code
      message
    }
  }
}
    `);
export const GetAvailabilityPhotoGradeSuggestionDocument = new TypedDocumentString(`
    query GetAvailabilityPhotoGradeSuggestion($photoId: String!) {
  availabilityPhotoGradeSuggestion(photoId: $photoId) {
    photoId
    itemId
    grade
  }
}
    `);
export const GetItemAvailabilityByDateDocument = new TypedDocumentString(`
    query GetItemAvailabilityByDate($input: ItemAvailabilityByDateInput!) {
  itemAvailabilityByDate(input: $input) {
    items {
      itemId
      asOf
      onHandReadyBy
      plantedReadyBy
      openDemandDueBy
      availableBy
      plannedReadyBy
    }
    errors {
      code
      message
    }
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetItemAvailability: build.query<GetItemAvailabilityQuery, GetItemAvailabilityQueryVariables | void>({
      query: (variables) => ({ document: GetItemAvailabilityDocument, variables })
    }),
    ResolveAvailabilityImportItems: build.query<ResolveAvailabilityImportItemsQuery, ResolveAvailabilityImportItemsQueryVariables>({
      query: (variables) => ({ document: ResolveAvailabilityImportItemsDocument, variables })
    }),
    GetAvailabilityPhotoGradeSuggestion: build.query<GetAvailabilityPhotoGradeSuggestionQuery, GetAvailabilityPhotoGradeSuggestionQueryVariables>({
      query: (variables) => ({ document: GetAvailabilityPhotoGradeSuggestionDocument, variables })
    }),
    GetItemAvailabilityByDate: build.query<GetItemAvailabilityByDateQuery, GetItemAvailabilityByDateQueryVariables>({
      query: (variables) => ({ document: GetItemAvailabilityByDateDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetItemAvailabilityQuery, useLazyGetItemAvailabilityQuery, useResolveAvailabilityImportItemsQuery, useLazyResolveAvailabilityImportItemsQuery, useGetAvailabilityPhotoGradeSuggestionQuery, useLazyGetAvailabilityPhotoGradeSuggestionQuery, useGetItemAvailabilityByDateQuery, useLazyGetItemAvailabilityByDateQuery } = injectedRtkApi;
